export default __webpack_public_path__ + "static/media/office.f44d4a5d.svg";